import { UserAuthRole } from 'lemunzo-api';

export class CurrentUser {
    constructor(
        public readonly id: string,
        public readonly email: string,
        public readonly name?: string,
        public readonly role?: UserAuthRole
    ) {}

    public isClientUser(): boolean {
        return this.role === UserAuthRole.User;
    }

    public isPlatformUser(): boolean {
        return (
            this.role === UserAuthRole.Member ||
            this.role === UserAuthRole.Admin ||
            this.role === UserAuthRole.SuperAdmin
        );
    }

    public isAdmin(): boolean {
        return this.role === UserAuthRole.Admin;
    }

    public isMember(): boolean {
        return this.role === UserAuthRole.Member;
    }

    public isSuperAdmin(): boolean {
        return this.role === UserAuthRole.SuperAdmin;
    }
}
